import Button from "core/components/new/Button"
import { format } from "date-fns"
import { useEffect, useState } from "react"
import UpdateProgressMeeting from "./UpdateProgressMeeting"
import GetClassAverageRating from "domain/useCase/Admin/AllClasses/GetClassAverageRating"
import GetAllClassesAPIDataSourceImpl from "data/API/Admin/GetAllClassesAPIDataSourceImpl"
import { GetAllClassesRepositoryImpl } from "data/repository/Admin/GetAllClassesRepositoryImpl"
import { useAuth } from "core/context/auth"
import Loader from "core/components/Loader"
import { isEmpty } from "core/utils/misc"
import Spinner from "core/components/Spinner"
import { useNavigate } from "react-router-dom"
import EditScheduledProgressMeetingModel from "./EditScheduledProgressMeetingModel"
import Toast from "core/components/Toast"
import CopyIcon from "assets/svgs/Copy"
import { STR_SUCCESS } from "core/constants/strings"
import { Link } from "react-router-dom"
import AdminSummaryModal from "./AdminSummaryModal"
import AllProgressMeetingsViewModel from "../AllProgressMeetingsViewModel"
import UpdateProgressMeetingForm from "./UpdateProgressMeetingForm"

export default function NewProgressMeetingCard({
  data,
  changeToastVisibility,
  changeToastDetails,
  fetchAllClassesDetails,
  loading,
  getBatchList,
  instructorList,
  updateClassBool,

  setUpdateClassBool,
}: any) {
  const { getMentorshipStats, getClassAttendanceStats, getExamStats } = AllProgressMeetingsViewModel()
  const [showDetailedRating, setShowDetailedRating] = useState(false)

  const [ClassAverageRating, setClassAverageRating] = useState<any>({})
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false)
  const openModal = () => {
    setIsSummaryModalOpen(true)
  }
  const closeModal = () => {
    setIsSummaryModalOpen(false)
  }

  const { auth } = useAuth()
  const navigate = useNavigate()

  const convertToMinutes = (timeString: string) => {
    const [hours, minutes] = timeString.split(/\D+/).map(Number)
    const totalMinutes = hours * 60 + minutes
    return totalMinutes
  }

  const GetClassAverageRatingUseCase = new GetClassAverageRating(
    new GetAllClassesRepositoryImpl(new GetAllClassesAPIDataSourceImpl())
  )
  const redirectToDetailedRating = (id: string) => {
    navigate(id)
  }
  const fetchClassAverageRatingDetails = async () => {
    const response = await GetClassAverageRatingUseCase.invoke(auth, data.session_id)

    if (!response?.success) {
      return
    }
    setClassAverageRating(response?.data)
  }

  const handleBatchAssignment = (session_id: string) => {
    navigate(`${session_id}/submission`)
  }

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }
  const baseUrl = "https://platform.bosscoderacademy.com/progress-meet-feedback"

  const handleCopy = (baseUrl: any, sessionId: any) => {
    const fullUrl = `${baseUrl}/${sessionId}` // Construct the full URL
    navigator.clipboard
      .writeText(fullUrl)
      .then(() => {
        changeToastDetails(STR_SUCCESS, "Link Copied Successfully!")
        changeToastVisibility(true)
      })

      .catch((err) => {
        console.error("Failed to copy URL: ", err)
      })
  }
  return (
    <div className="p-6 text-new-neutral-dark shadow rounded-[4px]">
      <div className="space-y-4">
        <div>
          <div className="flex justify-between">
            <h3>{data.chapter_name}</h3>

            {data.hasOwnProperty("class_strength") && data.hasOwnProperty("students_present") && (
              <div>
                Attendance: {data?.students_present}/{data?.class_strength}{" "}
                <span className="text-slate-500">
                  ({((data?.students_present / data?.class_strength) * 100).toFixed(2)}%)
                </span>
              </div>
            )}
            {!data?.class_rating || data?.num_rating === 0 ? (
              <div className="flex"> {/* <h3 className="text-slate-500 px-1">Not Rated</h3> */}</div>
            ) : (
              <div className="flex">
                {" "}
                <h3 className="text-new-success">
                  {Number.isInteger(data?.class_rating) ? data?.class_rating : data?.class_rating.toFixed(2)}/5 Rating
                  <span className="text-slate-500 px-1">({data?.num_rating})</span>
                </h3>
              </div>
            )}
          </div>
          <div className="flex pt-1 flex-wrap">
            {!isEmpty(data?.batches) ? (
              data.batches.map((item: string, i: number) =>
                i === 0 ? (
                  <p key={i} className="">
                    {item}
                  </p>
                ) : (
                  <p key={i} className="flex flex-wrap">{` | ${item} `}</p>
                )
              )
            ) : (
              <p className="italic">No Batch Found</p>
            )}
          </div>

          <div className="flex justify-between lg:flex-row flex-col space-y-2">
            <p className="flex flex-col-reverse font-bold">
              Instructor: {data.instructor != "" ? data.instructor : "No Instructor Found"}
            </p>

            <div className="flex items-baseline flex-wrap space-y-1">
              <button onClick={() => handleCopy(baseUrl, data?.progress_meeting_id)}>
                <CopyIcon></CopyIcon>
              </button>
              <Button outlined className="w-[200px] h-[30px] mx-1" onClick={toggleModal}>
                Update Information
              </Button>
              <Link to={`/admin/progress-meetings-feedback?meetingId=${data.progress_meeting_id}`}>
                <Button outlined className="w-[200px] h-[30px] mx-1">
                  Feedback
                </Button>
              </Link>
            </div>
          </div>
        </div>

        <div className="flex bg-gray-100 gap-4 font-semibold p-4 flex-wrap rounded-[4px]">
          <p>{data.module_id}</p>
          <p className="">
            <strong>AD : </strong>
            {data.duration ? `${Math.floor(data?.duration / 60)} min ${data?.duration % 60} sec` : "0 min"}
          </p>
          <p className="">
            <strong>CD : </strong>
            {data.duration ? `${Math.floor(data?.duration / 60)} min ${data?.duration % 60} sec` : "0 min"}
          </p>
          {data?.video_id ? (
            <p style={{ color: "#00AB66" }}>Rec-Uploaded</p>
          ) : (
            <p style={{ color: "#EF0107" }}>Rec-Not Uploaded</p>
          )}
          <p className="">{format(parseInt(data.session_timestamp) * 1000, "do MMMM, yyyy | hh:mm a")}</p>
          <Button
            outlined
            className=" w-[200px] h-[30px] mx-1 ml-auto"
            onClick={() => {
              setIsSummaryModalOpen(true)
            }}
          >
            Summary
          </Button>
          <AdminSummaryModal
            isOpen={isSummaryModalOpen}
            setIsOpen={closeModal}
            meetingDate={data.session_timestamp}
            batches={data.batches}
          />
        </div>
      </div>

      <EditScheduledProgressMeetingModel isOpen={isModalOpen} onClose={toggleModal}>
        <UpdateProgressMeeting
          updateClassBool={updateClassBool}
          setUpdateClassBool={setUpdateClassBool}
          batch={getBatchList}
          currentSelectBatch={data?.batches}
          chapterNames={data?.chapter_name}
          classLink={data?.class_link}
          selectInstructor={data?.instructor}
          selectModuleId={data?.module_id}
          notes_link={data?.notes_link}
          session_timestamp={data?.session_timestamp}
          summary={data?.summary}
          changeToastVisibility={changeToastVisibility}
          changeToastDetails={changeToastDetails}
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          session_id={data?.progress_meeting_id}
          instructor_name={data?.instructor_name}
          class_name={data?.chapter_name}
          data={data}
          videoId={data?.video_id}
          videoSecret={data?.video_secret}
          loading={loading}
          fetchAllClassesDetails={fetchAllClassesDetails}
        />
      </EditScheduledProgressMeetingModel>
    </div>
  )
}
